import React, { ReactNode } from 'react';
import styled, { css, keyframes } from 'styled-components';
import queryString from 'query-string';
import echarts from 'echarts';
import Hammer from 'hammerjs';
import PropTypes from 'prop-types';
import ReactGA from 'react-ga';

import { media } from '../../common/Layout';

// type StyledType = {
//   isSelectButton: boolean;
// };

const TopicNetworkComponent = styled.div`
  margin-top: 24px;
  width: 100%;
  border-radius: 8px;
  border: solid 1px #e1e6f0;
  padding: 20px;

  /* Mobile Device */
  margin-top: 26px;
  margin-bottom: 26px;

  ${media.desktop`
    margin-top: 24px;
    margin-bottom: 0px;
  `};
`;

const TopicNetworkTitleBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const TopicNetworkTitleText = styled.div`
  font-family: 'NotoKrM';
  font-size: 18px;
  font-weight: 500;
`;

const ButtonGroup = styled.div`
  display: flex;
  align-items: center;
`;

const ButtonTerm = styled.div`
  font-family: 'NotoKrL';
  font-size: 14px;
  font-weight: 300;
  color: #666666;
  height: 20px;
  /* width: 25px; */
  cursor: pointer;

  & + & {
    margin-left: 6px;
  }
  ${(props) => {
    if (props.isSelectButton) {
      return css`
        font-family: 'NotoKrM';
        font-weight: 500;
        color: #000000;
        border-bottom: 1px solid #000000;
      `;
    }
    return css`
      padding-top: 1px;
    `;
  }}
`;

const TopicNetworkContainer = styled.div`
  position: relative;
  margin-top: 15px;
  height: 350px;
`;

const ItemContainer = styled.div`

  width: 100%;
  height: 350px;
  z-index: 999;
  display: flex;
  
  /* ${(props) => {
    if (props.isSelectButton) {
      return css`
        display: block;
      `;
    }
    return css`
      display: none;
    `;
  }} */
`;

class TopicNetwork extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isSelectButtonMonth: true,
      isSelectButtonWeek: false,
    };
    this.keyword = '';
  }

  componentDidMount() {
    const { crawler_data_ai_network_data } = this.props;
    this.makeNetworkGraph(crawler_data_ai_network_data);
  }

  shouldComponentUpdate(nextProps, nextState) {
    const { crawler_data_ai_network_data } = this.props;
    const { isSelectButtonMonth } = this.state;

    if (
      nextProps.crawler_data_ai_network_data !== crawler_data_ai_network_data
    ) {
      this.makeNetworkGraph(nextProps.crawler_data_ai_network_data);
      return true;
    }
    if (nextState.isSelectButtonMonth !== isSelectButtonMonth) {
      return true;
    }
    return false;
  }

  onClickTabMonth = () => {
    const { onGetPathNetwork } = this.props;
    const query = queryString.parse(window.location.search);
    let keyword = '';

    if (query.q) {
      keyword = query.q;
    }
    onGetPathNetwork({
      query: keyword,
      date_unit: 'month',
    });
    this.setState({
      isSelectButtonMonth: true,
      isSelectButtonWeek: false,
    });
  };

  onClickTabWeek = () => {
    const { onGetPathNetwork } = this.props;
    const query = queryString.parse(window.location.search);
    let keyword = '';

    if (query.q) {
      keyword = query.q;
    }
    onGetPathNetwork({
      query: keyword,
      date_unit: 'week',
    });
    this.setState({
      isSelectButtonMonth: false,
      isSelectButtonWeek: true,
    });
  };

  makeNetworkGraph(crawler_data_ai_network_data) {
    const network = document.getElementById('topicNetwork');
    let mouseDown = false;

    const tempData = crawler_data_ai_network_data;

    if (network && tempData) {
      const myCharts = echarts.init(network);
      const mc = new Hammer(network);

      const categoriesPallete = ['#1a0dab', '#24b1f2', '#14ccad'];
      const categories = [];
      const nodeValue = [];

      for (let i = 0; i < 3; i += 1) {
        categories[i] = {
          name: `${i}`,
          itemStyle: {
            color: categoriesPallete[i],
          },
          label: {
            show: false,
          },
        };
      }

      tempData.nodes.forEach(function (node, index) {
        let itemValue = node.value;
        if (itemValue > 50) {
          itemValue = 50;
        } else if (itemValue < 10) {
          itemValue = 10;
        }
        nodeValue.push({
          id: node.id,
          value: node.value,
        });

        node.itemType = 'node';
        node.itemStyle = null;
        node.symbolSize = itemValue;
        node.category = node.category || 1;
        node.x = null;
        node.y = null;
        node.label = {
          normal: {
            show: node.symbolSize > 9,
          },
        };
        if (node.depth) {
          if (node.depth === 0) {
            node.category = 0;
          } else if (node.depth === 1) {
            node.category = 1;
          } else if (node.depth === 2) {
            node.category = 2;
          }
        } else if (index === 0) {
          node.category = 0;
        }
      });

      // tempData.edge.forEach(function (edge) {
      //   edge.itemType = 'edge';
      //   edge.value = edge.value;
      //   edge.source = edge.source;
      //   edge.target = edge.target;
      // });

      const option = {
        title: [
          {
            show: false,
            text: '데이터가 없습니다.',
            left: 'center',
            top: 'middle',
            textStyle: {
              fontSize: 13.5,
              fontWeight: 400,
            },
          },
        ],

        legend: [
          {
            show: false,
            data: categories.map(function (a) {
              return a.name;
            }),
          },
        ],

        series: [
          {
            name: '',
            type: 'graph',
            layout: 'force',
            data: tempData.nodes,
            links: tempData.edge,
            categories,
            roam: true,
            label: {
              show: true,
              position: 'bottom',
            },
            lineStyle: {
              color: '#62a7c3',

              curveness: 0,
              width: 1.1,
            },
            force: {
              layoutAnimation: true,
              repulsion: 200,
              edgeLength: [1, 100],
              gravity: 0.1,
            },
            zoom: 1,
            nodeScaleRatio: 0.3,
          },
        ],
      };
      myCharts.setOption(option, true);
      myCharts.on('click', (params) => {
        if (params.dataType === 'node') {
          ReactGA.ga('send', 'event', `click_search_ai_network_node`);
          this.keyword = params.name;
          window.history.pushState(null, null, `/search/ai?q=${params.name}`);
          window.location.reload(true);
        }
      });
      const tempNetworkData = {
        edge: [],
        nodes: [],
      };

      if (tempData.nodes.length === tempNetworkData.nodes.length) {
        myCharts.setOption({
          title: [
            {
              show: true,
            },
          ],
        });
      }

      mc.get('pinch').set({ enable: true });

      mc.on('pinchin', function (ev) {
        ev.preventDefault();
        if (myCharts.getOption().series[0].zoom < 1.0) {
          myCharts.setOption({
            series: [
              {
                roam: 'move',
              },
            ],
          });
        } else {
          myCharts.setOption({
            series: [
              {
                roam: true,
              },
            ],
          });
        }
      });

      mc.on('pinchout', function (ev) {
        ev.preventDefault();
        if (myCharts.getOption().series[0].zoom > 2.5) {
          myCharts.setOption({
            series: [
              {
                roam: 'move',
              },
            ],
          });
        } else {
          myCharts.setOption({
            series: [
              {
                roam: true,
              },
            ],
          });
        }
      });

      network.addEventListener(
        'mousewheel',
        (event) => {
          event.preventDefault();
          if (event.wheelDelta >= 0) {
            mouseDown = false;
          } else {
            mouseDown = true;
          }

          if (myCharts.getOption().series[0].zoom < 0.7) {
            if (mouseDown) {
              myCharts.setOption({
                series: [
                  {
                    roam: 'move',
                  },
                ],
              });
            } else {
              myCharts.setOption({
                series: [
                  {
                    roam: true,
                  },
                ],
              });
            }
          } else if (myCharts.getOption().series[0].zoom > 1.5) {
            if (!mouseDown) {
              myCharts.setOption({
                series: [
                  {
                    roam: 'move',
                  },
                ],
              });
            } else {
              myCharts.setOption({
                series: [
                  {
                    roam: true,
                  },
                ],
              });
            }
          }
        },
        true
      );
    }
    // else {
    //   const myCharts = echarts.init(network);
    //   const option = {
    //     title: [
    //       {
    //         show: true,
    //         text: '데이터가 없습니다.',
    //         left: 'center',
    //         top: 'middle',
    //         textStyle: {
    //           fontSize: 13.5,
    //           fontWeight: 400,
    //         },
    //       },
    //     ],

    //     series: [
    //       {
    //         name: '',
    //         type: 'graph',
    //         layout: 'force',

    //         roam: true,
    //         label: {
    //           show: true,
    //           position: 'bottom',
    //         },
    //         lineStyle: {
    //           color: '#62a7c3',

    //           curveness: 0,
    //           width: 1.1,
    //         },
    //         force: {
    //           layoutAnimation: true,
    //           repulsion: 200,
    //           edgeLength: [1, 100],
    //           gravity: 0.1,
    //         },
    //         zoom: 1,
    //         nodeScaleRatio: 0.3,
    //       },
    //     ],
    //   };
    //   myCharts.setOption(option, true);
    // }
  }

  render() {
    const { isSelectButtonMonth, isSelectButtonWeek } = this.state;
    return (
      <TopicNetworkComponent>
        <TopicNetworkTitleBox>
          <TopicNetworkTitleText>토픽네트워크</TopicNetworkTitleText>
          {/* <ButtonGroup>
            <ButtonTerm
              isSelectButton={isSelectButtonMonth}
              onClick={this.onClickTabMonth}
            >
              월간
            </ButtonTerm>
            <ButtonTerm
              isSelectButton={isSelectButtonWeek}
              onClick={this.onClickTabWeek}
            >
              주간
            </ButtonTerm>
          </ButtonGroup> */}
        </TopicNetworkTitleBox>
        <TopicNetworkContainer>
          <ItemContainer
            id="topicNetwork"
            isSelectButton={isSelectButtonMonth}
          />
        </TopicNetworkContainer>
      </TopicNetworkComponent>
    );
  }
}

export default TopicNetwork;
TopicNetwork.defaultProps = {
  crawler_data_ai_network_data: { nodes: [], edge: [] },
};

TopicNetwork.propTypes = {
  crawler_data_ai_network_data: PropTypes.shape({}),
  onGetPathNetwork: PropTypes.func.isRequired,
};
